import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, effect, input, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { Select } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'app-tabs',
  imports: [CommonModule, TranslocoPipe, FormsModule, Select, TabsModule],
  template: `
    <p-tablist [attr.class]="tabsClass() + ' md:overflow-hidden max-md:!hidden'">
      @for (tab of tabs(); track tab.value) {
        @if (tab.disabled) {
          <div class="p-ripple p-tab !cursor-not-allowed" [attr.title]="'global.comingSoon' | transloco">
            <p-tab [value]="tab.value" (click)="onPListChange(tab.value)" [disabled]="tab.disabled">
              {{ tab.title }}
            </p-tab>
          </div>
        } @else {
          <p-tab [value]="tab.value" [attr.title]="tab.title" (click)="onPListChange(tab.value)" [disabled]="tab.disabled">
            {{ tab.title }}
          </p-tab>
        }
      }
    </p-tablist>
    <p-select
      [options]="tabs()"
      [(ngModel)]="internalSelectedTab"
      optionLabel="title"
      [attr.placeholder]="placeholder()"
      [attr.class]="selectClass() + '  md:!hidden'"
      [disabled]="disabled()"
      [panelStyle]="{ maxWidth: '80dvw' }"
      scrollHeight="500px" />
  `,
  host: {
    class: 'qira-tabs',
  },
  encapsulation: ViewEncapsulation.None,
  styles: `
    .qira-tabs {
      .p-overlay {
        @apply right-0;
      }
    }
  `,
})
export class TabsComponent {
  tabs = input<any[]>([]);
  selectedTab = model.required<string | number>();
  internalSelectedTab = signal<any>(this.tabs()?.[0] || undefined);
  optionLabel = input<string>('title');
  placeholder = input<string>('Auswählen');
  disabled = input<boolean>(false);
  selectClass = input<string>('');
  tabsClass = input<string>('');

  onInit = effect(() => {
    const selected = this.tabs().find((tab) => tab.value === this.selectedTab());
    if (selected) {
      this.internalSelectedTab.set(selected);
    }
  });

  onPSelectChange = effect(() => {
    const newSelection = this.tabs().find((tab) => tab.value === this.internalSelectedTab().value);
    if (newSelection) {
      this.selectedTab.set(newSelection.value);
    }
  });

  onPListChange(event: any) {
    const selected = this.tabs().find((tab) => tab.value === event);
    if (selected) {
      this.selectedTab.set(selected.value);
    }
  }
}
